import { SVGProps, Ref, forwardRef } from 'react';

export const MoonStarFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M7.17 1.916c3.942-2.174 2.378-.183 1.92 2.883-.907 6.067 4.044 11.017 10.111 10.111 3.066-.458 5.056-2.022 2.883 1.918C20.11 20.406 16.487 23 12.123 23 5.98 23 1 18.02 1 11.877 1 7.513 3.593 3.89 7.17 1.916"
                fill="currentColor"
            />
        </g>
    </svg>
));
MoonStarFilledSize24Glyph.displayName = 'MoonStarFilledSize24Glyph';
